// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__BTMmb","colMin":"styles_colMin__20g_9","colCheckbox":"styles_colCheckbox__1RvJ4"};